export default {
  route: {
    invalidUrl: '此網址並未指向有效的專案。',
    notFound: '此幾何不存在，或您沒有存取權限。',
  },
} as const;
